'use client';

/**
 * 全局的错误处理页面
 */
import ErrorImg from '/public/error-page.svg';
import { cn } from '@/lib/utils';
import { i18n } from '@/i18n';

// TODO 完善
const CONFIG = {
  default: {
    image: ErrorImg,
    message: i18n.t('common:errorPage.defaultMessage'),
  },
};

interface ErrorPageProps {
  type?: string;
  message?: string;
  defaultMessage?: string;
  className?: string;
}

const ErrorPage = ({
  type = 'default',
  message,
  defaultMessage,
  className,
}: ErrorPageProps) => {
  const config = CONFIG[type] || CONFIG.default;
  const msg = message || defaultMessage || config.message;
  const Img = config.image;
  return (
    <div
      className={cn(
        'w-full h-full flex flex-col items-center justify-center gap-4',
        className,
      )}
    >
      <Img className="w-[208px] h-[95px]" />
      <div>{msg}</div>
    </div>
  );
};

export default ErrorPage;
